import {
  NgModule
} from '@angular/core';

import {
  LoginComponent
} from './login.component';

import {
  SharedCommonModule
} from '../shared/common';

import {
  AuthService
} from '../services/auth/auth.service';

import {
  UserContext
} from '../services/user-context';

// import {
//   JwtHelper
// } from 'angular2-jwt';
import {
  LoginDialogComponent
} from './components/login-dialog/login-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator/loading-indicator.module';
import {JwtHelperService} from "@auth0/angular-jwt";
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [
    LoginComponent,
    LoginDialogComponent
  ],
  imports: [
    SharedCommonModule,
    MatDialogModule,
    MatSnackBarModule,
    LoadingIndicatorModule,
    ButtonsModule,
    InputsModule,

  ],
  providers: [
    AuthService,
    UserContext,
    JwtHelperService
  ],
  entryComponents: [
    LoginDialogComponent
  ]
})
export class LoginModule {
}
